module.exports = __webpack_public_path__ + "img/zhzs.d054722.png";